import { GENERATE_OTP_FORGOT_PASSWORD, VERIFY_OTP_FORGOT_PASSWORD, RESET_PASSWORD } from '../../data/APIEndpoints';
import axios from '../AxiosInstance';

const generateOTPForgotPassword = async (emailID) => {
    try {
        const response = await axios.post(GENERATE_OTP_FORGOT_PASSWORD,
            {
                email: emailID
            }
        )
        if(response.status === 200 || response.status === 201) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "Invalid Email or Email doesn't exist",
            error: error,
        };
    }
}

const validateOTPForgotPassword = async (otpRequest) => {
    try {
        const response = await axios.put(VERIFY_OTP_FORGOT_PASSWORD,
            otpRequest
        )
        if(response.status === 200 || response.status === 201) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        return {
            status: "error",
            message: "Invalid OTP or OTP has expired.",
            error: error,
        };
    }
}

const resetPassword = async (resetPasswordRequest) => {
    try {
        const response = await axios.put(RESET_PASSWORD,
            resetPasswordRequest
        )
        if(response.status === 200 || response.status === 201) {
            return { status: "success", data: response.data };
        }
    }
    catch(error) {
        if(error.response.data.message){
            return {
                status: "error",
                message: error.response.data.message,
                error: error,
            };
        } else {
            return {
                status: "error",
                message: "Failed to Reset Password",
                error: error,
            };
        }
        
    }
}

const ForgotPasswordPageAPI = {
    generateOTPForgotPassword,
    validateOTPForgotPassword,
    resetPassword
}

export default ForgotPasswordPageAPI;